import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TotalApplicationsCountState {
  total: number;
}

const initialState: TotalApplicationsCountState = {
  total: 0,
};

const totalApplicationsCountSlice = createSlice({
  name: 'totalApplications',
  initialState,
  reducers: {
    setTotalCount(state, action: PayloadAction<number>) {
      state.total = action.payload;
    },
  },
});

export const totalApplicationsCountActions =
  totalApplicationsCountSlice.actions;
export default totalApplicationsCountSlice.reducer;
